export default "__VITE_ASSET__4i7bxGlG__"